import React from 'react';

import { Button } from '@infoods/lifebase-ui';

import { PageTitle } from '../../../../../../shared/components/ui-components';
import { corporateAccountsStore } from '../../../../../stores/corporateAccountsStore';

const CorporateAccountsTabTitle = () => {
  const { openModal } = corporateAccountsStore;

  const handleOpenAddModal = () => {
    openModal();
  };

  return (
    <PageTitle title="Corporate Accounts">
      <Button onClick={handleOpenAddModal} variant="contained">
        Add Corporate Account
      </Button>
    </PageTitle>
  );
};

export { CorporateAccountsTabTitle };
